import axios from 'axios'
import { Toast } from 'vant';
import VueCookies from 'vue-cookies'
import qs from 'qs'

let ConfigBaseURL = '/api30' //默认路径，这里也可以使用env来判断环境

let loadingInstance = null //这里是loading
//使用create方法创建axios实例
export const Service = axios.create({
  timeout: 60000, // 请求超时时间
  baseURL: ConfigBaseURL,
  method: 'post',
  data:{}
})
// 添加请求拦截器
// Service.interceptors.request.use(config => {
//   loadingInstance = Loading.service({
//     lock: true,
//     text: 'loading...'
//   })
//   return config
// })
// 添加响应拦截器
Service.interceptors.request.use(
  config => {
    // console.log('config',config)
    // if (config.method.toLowerCase() == 'post') {
    // config.headers['token'] = sessionStorage.getItem('token')
    // config.headers['_up_'] = '0|0|0|0|0|0'
    config.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
    config.data.token = VueCookies.get("user_token")
	let userId=0;
	if(VueCookies.isKey("userId"))
	{
		userId=VueCookies.get("userId");
	}
	config.data._up_=userId+'|0|0|0|0';
	config.data = qs.stringify(config.data)

    
    // config.headers('Access-Control-Allow-Origin: *')
    // }
    return config
  },
  error => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
  },
)

Service.interceptors.response.use(response => {
  //loadingInstance.close()
  // console.log(response)
  return response.data
}, error => {
  console.log('TCL: error', error)
  const msg = error.Message !== undefined ? error.Message : ''
  Toast('网络错误' + msg)
  loadingInstance.close()
  return Promise.reject(error)
})